import { render, staticRenderFns } from "./tabletwo.vue?vue&type=template&id=0b7cc0d2&scoped=true&"
import script from "./tabletwo.vue?vue&type=script&lang=js&"
export * from "./tabletwo.vue?vue&type=script&lang=js&"
import style0 from "./tabletwo.vue?vue&type=style&index=0&id=0b7cc0d2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7cc0d2",
  null
  
)

export default component.exports